import { v4 as uuidv4 } from "uuid";
import * as types from "./CartTypes";

const INITIAL_STATE = {
  hotelKey: null,
  checkoutDetails: {},
  data: [],
  priceSummary: {
    subTotal: 0,
    deliveryCharge: 0,
    serviceCharge: 0,
    discount: 0,
    tax: 0,
    total: 0,
  },
  couponLoaded: false,
  coupons: [],
  selectedCoupon: {},
  availableCoupons: [],
  selectedTable: {},
  guestCount: 1,
};

// Replace with you own reducer
const reducer = (state = INITIAL_STATE, { ...action }) => {
  switch (action.type) {
    case types.UPDATE_CART:
      const _index = state.data.findIndex(
        (p) => p._cartItemId === action.payload._cartItemId
      );
      if (_index > -1) {
        action.payload.count === 0
          ? state.data.splice(_index, 1)
          : (state.data[_index].count = action.payload.count);
        state.data[_index].modifiers = [...action.payload.modifiers];
        state.data[_index].size = action.payload.size;
        state.data[_index].extraComments = action.payload.extraComments;
        state.data[_index].combos = action.payload.combos || {};
      } else {
        state.data.push({
          _cartItemId: uuidv4(),
          ...action.payload,
        });
      }
      return {
        ...state,
      };
    case types.DELETE_FROM_CART:
      const _reomveProductIndex = state.data.findIndex(
        (p) => p._cartItemId === action.payload._cartItemId
      );
      if (_reomveProductIndex > -1) {
        state.data.splice(_reomveProductIndex, 1);
      }
      return {
        ...state,
      };
    case types.SAVE_CHECKOUT_DETAILS:
      return {
        ...state,
        checkoutDetails: {
          ...state.checkoutDetails,
          ...action.payload,
        },
      };
    case types.PROCESS_CART:
      const { hotelKey, catrgories } = action.payload;
      const currentDataInCart = state.data.slice();
      const updatedDataInCart = [];

      if (state.hotelKey !== hotelKey) {
      } else if (currentDataInCart.length > 0) {
        for (let i = 0; i < currentDataInCart.length; i++) {
          if (currentDataInCart[i].combo_id && catrgories?.combos?.length > 0) {
            const selectedItem = catrgories?.combos?.find(
              (it) => it.combo_id === currentDataInCart[i].combo_id
            );

            if (selectedItem) {
              updatedDataInCart.push({
                ...currentDataInCart[i],
                // ...selectedItem,
              });
            }
          } else {
            if (catrgories?.data?.length > 0) {
              const selectedCategory = catrgories?.data?.find(
                (c) => c.categoryId === currentDataInCart[i].categoryId
              );
              const selectedItem = selectedCategory?.item.find(
                (it) => it.itemId === currentDataInCart[i].itemId
              );
              if (selectedItem) {
                updatedDataInCart.push({
                  ...currentDataInCart[i],
                  ...selectedItem,
                });
              }
            }
          }
        }
      }
      return {
        ...state,
        hotelKey,
        data: updatedDataInCart,
      };
    case types.CLEAR_CART:
      return {
        ...state,
        checkoutDetails: {},
        data: [],
        priceSummary: {
          subTotal: 0,
          deliveryCharge: 0,
          serviceCharge: 0,
          discount: 0,
          tax: 0,
          total: 0,
        },
      };
    case types.PRICE_SUMMARY:
      return {
        ...state,
        priceSummary: { ...state.priceSummary, ...action.payload },
      };
    case types.GET_COUPON_REQUEST:
      return {
        ...state,
        couponLoaded: false,
      };
    case types.GET_COUPON_RECEIVE:
      return {
        ...state,
        coupons: action.payload || [],
        couponLoaded: true,
      };
    case types.SELECT_COUPON:
      return {
        ...state,
        selectedCoupon: action.payload || {},
      };
    case types.CLEAR_COUPON:
      return {
        ...state,
        selectedCoupon: {},
      };
    case types.SET_AVAILABLE_COUPONS:
      return {
        ...state,
        availableCoupons: action.payload || [],
      };
    case types.CLEAR_AVAILABLE_COUPONS:
      return {
        ...state,
        availableCoupons: [],
      };
    case types.SELECT_TABLE:
      return {
        ...state,
        selectedTable: action.payload || {},
      };
    case types.CLEAR_TABLE_SELECTION:
      return {
        ...state,
        selectedTable: {},
      };
    case types.SET_GUESTS_COUNT:
      return {
        ...state,
        guestCount: action.payload || 1,
      };
    default:
      return state;
  }
};

export default reducer;
